import { writable } from 'svelte/store';
import { SplitFactory } from '@splitsoftware/splitio';
import { getFeatureFlag, getUniqueUser } from './../helpers';
const core = {
    authorizationKey: 'process.env.SPLIT_AUTHORIZATION_KEY',
    key: getFeatureFlag() || getUniqueUser()
};
function createSplitIo() {
    const { subscribe, set, update } = writable({
        ready: false
    });
    const factory = SplitFactory({ core });
    const client = factory.client();
    client.on(client.Event.SDK_READY, () => {
        update((state) => (Object.assign(Object.assign({}, state), { ready: true })));
    });
    return {
        subscribe,
        client,
        getTreatment: (flag) => client.getTreatment(flag),
        getTreatments: (flags) => client.getTreatments(flags)
    };
}
const splitIo = createSplitIo();
export { splitIo };
